<template>
  <v-form v-model="formValid" ref='cancerComboForm'>
    <v-autocomplete
      v-model="currentModel[modifyIndex].cancerConditions"
      :items="cancerListView"
      filled
      chips
      color="blue-grey lighten-2"
      label="Select the type(s) of cancer:"
      multiple
    >
      <template v-slot:selection="data">
        <v-chip
          :v-model="data.selected"
          close
          class="chip--select-multi"
          @input="remove(data.item)"
        >{{ data.item }}</v-chip>
      </template>
      <template v-slot:item="data">
        <template v-if="typeof data.item !== 'object'">
          <v-list-item-content v-text="data.item"></v-list-item-content>
        </template>
      </template>
    </v-autocomplete>

    <v-text-field
      v-if="currentModel[modifyIndex].cancerConditions.includes('Other')"
      v-model="currentModel[modifyIndex].cancerOther"
      label="What is the name of the Cancer"
    ></v-text-field>
    <v-spacer></v-spacer>
    <v-text-field
      v-for="conditon in currentModel[modifyIndex].cancerConditions"
      v-bind:key="conditon"
      type="number"
      :rules='ageRules'
      required
      v-model="currentModel[modifyIndex].cancerConditionsDx[`${conditon}`]"
      :label="`Age diagnosed with ${conditon} cancer`"
    ></v-text-field>
  </v-form>
</template>


<script>
import { mapFields } from "vuex-map-fields";
export default {
  props: {
    modifyIndex: Number,
    modelType: String
  },

  mounted() {
    this.checkGender();
  },
  methods: {
    checkGender() {
      if (
        this.currentModel[this.modifyIndex].gender === "Female" ||
        this.currentModel[this.modifyIndex].gender === "Transgender Female" ||
        this.currentModel[this.modifyIndex].gender ===
          "Gender variant/non-conforming"
      ) {
        this.cancerListView = this.cancerList.filter(item => {
          return item !== "Prostate" && item !== "Testicular";
        });
        return this.cancerListView;
      } else {
        this.cancerListView = this.cancerList.filter(item => {
          return (
            item !== "Ovarian" && item !== "Uterine" && item !== "Cervical"
          );
        });
        return this.cancerListView;
      }
    },
    remove(item) {
      const index = this.currentModel[
        this.modifyIndex
      ].cancerConditions.indexOf(item);
      if (index >= 0)
        this.currentModel[this.modifyIndex].cancerConditions.splice(index, 1);
      delete this.currentModel[this.modifyIndex].cancerConditionsDx[item];
    }
  },
  data() {
    return {
      cancerListView: [],
      ageRules: [
        v => (v && v >= 0) || 'Age must be larger than 0'
      ],
    };
  },
  computed: {
    ...mapFields("patientQuestion", [
      "GeneticTrustdataModel",
      "dataModel",
      "cancerList",
      "formValid"
    ]),
    currentModel() {
      switch (this.modelType) {
        case "GeneticTrustdataModel":
          return this.GeneticTrustdataModel;
        default:
          return this.dataModel;
      }
    }
  }
};
</script>
